import { useConexaQuery } from '@/hooks/useConexaQuery'
import { callAppointmentMonitoring } from '../video-call-services'

const ONE_MINUTES_IN_MS = 60000

export const useCallAppointmentMonitoring = (
  id: string | number,
  refetchInterval = false,
  enabled = true,
) => {
  return useConexaQuery({
    queryKey: ['call-appointment-monitoring', id],
    service: () => callAppointmentMonitoring(id),
    config: {
      enabled: Boolean(id) && enabled,
      refetchOnWindowFocus: true,
      refetchIntervalInBackground: true,
      refetchInterval(data) {
        if (!refetchInterval) return false

        const hasMeetUrl = Boolean(data?.meetUrl)

        if (hasMeetUrl) return false

        return ONE_MINUTES_IN_MS
      },
    },
  })
}
